import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import DesignProcess from '@/views/DesignProcess.vue';
import Services from '@/views/Services.vue';
import Signup from '@/views/Signup.vue';
import SignupIntro from '@/views/SignupIntro.vue';
import SignUpCustomer from '@/views/SignUpCustomer.vue';
import SignUpProjectGoals from '@/views/SignUpProjectGoals.vue';
import SignUpMeasurements from '@/views/SignUpMeasurements.vue';
import SignUpInspirationPhotos from '@/views/SignUpInspirationPhotos.vue';
import SignUpRoomPhotos from '@/views/SignUpRoomPhotos.vue';
import SignupComplete from '@/views/SignupComplete.vue';
import Art from '@/views/Art.vue';
import Admin from '@/views/Admin.vue';
import Contact from '@/views/Contact.vue';
import AdminPortfolio from '@/views/AdminPortfolio.vue';
import AdminPortfolioList from '@/views/AdminPortfolioList.vue';
import PortfolioList from '@/views/PortfolioList.vue';
import PortfolioDetail from '@/views/PortfolioDetail.vue';
import AdminSignupDetail from '@/views/AdminSignupDetail.vue';
import AdminSignupList from '@/views/AdminSignupList.vue';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '/',
    redirect: { name: 'PortfolioList' },
  },

  {
    path: '/portfolio',
    name: 'PortfolioList',
    component: PortfolioList,
  },

  {
    path: '/portfolio/:id',
    name: 'PortfolioDetail',
    component: PortfolioDetail,
  },

  {
    path: '/process',
    name: 'DesignProcess',
    component: DesignProcess,
  },

  {
    path: '/services',
    name: 'Services',
    component: Services,
  },

  {
    path: '/signup',
    component: Signup,
    children: [
      {
        path: '/',
        name: 'SignupIntro',
        component: SignupIntro,
      },
      {
        path: 'customer',
        name: 'SignupCustomer',
        component: SignUpCustomer,
      },
      {
        path: 'room',
        name: 'SignupProjectGoals',
        component: SignUpProjectGoals,
      },
      {
        path: 'photos',
        name: 'SignupRoomPhotos',
        component: SignUpRoomPhotos,
      },
      {
        path: 'inspiration',
        name: 'SignupInspirationPhotos',
        component: SignUpInspirationPhotos,
      },
      {
        path: 'measurements',
        name: 'SignupMeasurements',
        component: SignUpMeasurements,
      },
      {
        path: 'complete',
        name: 'SignupComplete',
        component: SignupComplete,
      },
    ],
  },

  {
    path: '/admin',
    component: Admin,
    children: [
      {
        path: '', redirect: { name: 'AdminPortfolioList' },
      },
      {
        path: 'projects',
        name: 'AdminPortfolioList',
        component: AdminPortfolioList,
      },
      {
        path: 'projects/:id',
        name: 'AdminPortfolio',
        component: AdminPortfolio,
      },
      {
        path: 'signups',
        name: 'AdminSignupList',
        component: AdminSignupList,
      },
      {
        path: 'signups/:id',
        name: 'AdminSignupDetail',
        component: AdminSignupDetail,
      },
    ],
  },

  {
    path: '/art',
    name: 'Art',
    component: Art,
  },

  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
  },

  {
    path: '/contact',
    name: 'Contact',
    component: Contact,
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
